import styled, { css, keyframes } from "styled-components";

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const flexColumn = css`
  display: flex;
  flex-direction: column;
`;

export const Container = styled.div`
  ${flexColumn};
  overflow: hidden;
`;

export const Content = styled.div`
  ${flexColumn};
`;

export const ContentContainer = styled.div`
  ${flexColumn};
`;

export const ContentWrapper = styled.div`
  ${flexColumn};
  animation: 0.2s ${fadeIn} linear forwards;
`;

export const LoadingContainer = styled.div`
  ${flexColumn};
  align-items: center;
  justify-content: center;
  height: 76px;
`;

export const PastPerformancesContainer = styled.div<{
  hasBorderTop: boolean;
}>`
  ${flexColumn};
  background-color: ${({ theme }) => theme.colorTokens.background.layer};
  ${({ hasBorderTop, theme }) =>
    hasBorderTop &&
    css`
      border-top: 1px solid ${theme.colorTokens.border.default};
    `};
`;

export const InlineAnalysesContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid ${({ theme }) => theme.colorTokens.border.default};
  background-color: ${({ theme }) => theme.colorTokens.background.layer};
  padding: ${({ theme }) => theme.space["space-4"]};
`;

export const SilkContainer = styled.div`
  ${flexColumn};
  flex-shrink: 0;
  margin-left: ${({ theme }) => theme.space["space-4"]};
  width: 34px;
`;

export const SilkImage = styled.img`
  display: flex;
  flex-shrink: 0;
  height: 48px;
`;

export const BetButtonsContainer = styled.div`
  ${flexColumn};
`;

export const RunnerChangesContainer = styled.div`
  ${flexColumn};
  border-top: 1px solid ${({ theme }) => theme.colorTokens.border.default};
  background-color: ${({ theme }) => theme.colorTokens.background.accent};
`;
